export default __webpack_public_path__ + "8b7d6c0cffb43b20e92d6f88f678be56.png";